import React from "react";
import { Button, Image, Layout, Menu, Spin, Space, theme, Popover, Badge } from "antd";
import { PATH } from "../routes/CustomRoutes";
import { MenuUnfoldOutlined,  MenuFoldOutlined,  UnlockOutlined,  LogoutOutlined,  DropboxOutlined,  FileFilled,  AreaChartOutlined, HistoryOutlined, ProductFilled, BookOutlined, ProfileFilled} from "@ant-design/icons";
import { useUserContext } from "../hooks/UserSettingProvider";
import { useNavigate, useParams } from "react-router-dom";
import { Content, Footer, Header } from "antd/es/layout/layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxesStacked , faTruck, faFlask, faBoxArchive, faDatabase ,faFileInvoiceDollar ,faGear ,faFileExport } from "@fortawesome/free-solid-svg-icons";
import ChangePasswordModal from '../components/user/ChangePasswordModal';
import LogoutModal from '../components/user/LogoutModal'; 
import * as _ from "lodash";
import Sider from "antd/es/layout/Sider";
import {  BG_LAYOUT_COLOR,  BLACK_COLOR,  PRIMARY_COLOR,  WHITE_COLOR_BG,} from "../constants/color";
import logo from "../asset/logo.jpg";
import ReceivingLatexView from "../views/ReceivingLatexView";
import LabLatexView from "../components/lab-latex/LabLatexView";
import PondLatexView from "../views/PondLatexView";
import StorageTankView from "../views/StorageTankView";
import PureChemicalView from "../views/PureChemicalView";
import DispenseChemicalView from "../views/DispenseChemicalView";
import SaleListView from "../views/SaleListView";
import PondTankSettingView from "../views/Setting/PondTankSettingView";
import BuyerSettingView from "../views/Setting/BuyerSettingView";
import FactorySettingsView from "../views/Setting/FactorySettingsView";
import ProductTypeSettingView from "../views/Setting/ProductTypeSettingView";
import SellerSettingView from "../views/Setting/SellerSettingView";
import ShippingSettingView from "../views/Setting/ShippingSettingView";
import { USER_GROUP } from "../constants/string";
import QualityChemicalView from "../components/chemical/QualityChemicalView";
import PurchaseView from "../views/PurchaseView";
import PurchaseCTTView from "../views/PurchaseCTTView";
import StorageSkimView from "../views/StorageSkimView";
import TruckHistoryView from "../views/TruckHistoryView";
import LabLatexQCView from "../views/LabLatexQCView";
import LabConcentrateQCView from "../views/LabConcentrateQCView";
import PondRecieveLatexView from "../views/PondRecieveLatexView";
import SkimChemicalView from "../views/SkimChemicalView";
import ProducePreorderView from "../views/ProducePreorderView";
import ReportView from "../views/ReportView";
import { useMenuNotificationContext } from "../hooks/MenuNotificationProvider";
import ManualView from "../views/ManualView"; 
import PaymentReportView from "../views/PaymentReportView"
import UserSettingView from "../views/Setting/UserSettingView";
const CODE_VERSION = "1.7.19"


export default function MenuScreen() {
  const params = useParams();
  const navigate = useNavigate();
  const { features, user } = useUserContext();
  const [currentMenu, setCurrentMenu] = React.useState(null);
  const [collapsed, setCollapsed] = React.useState(false);
  const [openUserMenu, setOpenUserMenu] = React.useState(false);
  const [openLogout, setOpenLogout] = React.useState(false);
  const [openChangePassword, setOpenChangePassword] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const { notification, fetchNotification } = useMenuNotificationContext();

  const {
    token: { colorBgContainer, colorPrimary },
  } = theme.useToken();

  // Check user permission
  const hasPermission = (target) => (user && user.groups &&  user.groups.length > 0 ? user.groups.find((group) => group === target) : true)
  // const hasPermission = (target) => (user && user.groups && user.groups.find((group) => group === target))


  const menus = [
    {
      key: PATH.RECEIVING_LATEX.substring(1),
      icon: <FontAwesomeIcon icon={faTruck} />,
      label: 'รับน้ำยางสด',
      permissions: (hasPermission(USER_GROUP.WEIGHT) || hasPermission(USER_GROUP.WT_LATEX))
    },
    {
      key: PATH.LAB_LATEX.substring(1),
      icon: <FontAwesomeIcon icon={faFlask} />,
      label: 'ห้อง Lab',
      permissions: (hasPermission(USER_GROUP.LAB))
    },
    {
      key: PATH.POND_LATEX.substring(1),
      icon: <FontAwesomeIcon icon={faBoxArchive} />,
      label: 'บ่อพักน้ำยางสด',
      // label: 'บ่อ',
      permissions: (hasPermission(USER_GROUP.POND) || hasPermission(USER_GROUP.RP)),
      notification: notification.pond,
    },
    // {
    //   key: PATH.POND_RECIEVE_LATEX.substring(1),
    //   icon: <FontAwesomeIcon icon={faFill} />,
    //   label: 'รับน้ำยางสด',
    //   permissions: (hasPermission(USER_GROUP.RP))
    // },
    {
      key: PATH.STORAGE_TANK.substring(1),
      icon: <FontAwesomeIcon icon={faDatabase} />,
      label: 'แทงก์น้ำยางข้น',
      // label: 'แทงก์',
      permissions: (hasPermission(USER_GROUP.TANK)),
      notification: notification.tank,
    },
    {
      // key: PATH.STORAGE_SKIM.substring(1),
      icon: <FontAwesomeIcon icon={faBoxesStacked} />,
      label: 'สกิม',
      permissions: (hasPermission(USER_GROUP.SKIM)),
      children: [
        { key: PATH.STORAGE_SKIM.substring(1), label: 'สต็อกสกิม', permissions : hasPermission(USER_GROUP.SKIM)},
        { key: PATH.SKIM_CHEMICAL.substring(1), label: 'สารเคมีสกิม', permissions : hasPermission(USER_GROUP.SKIM)},
      ]
    },
    {
      icon: <AreaChartOutlined />,
      label: '%DRC/จ่ายเงิน',
      permissions: (hasPermission(USER_GROUP.PURCHASE) || hasPermission(USER_GROUP.WT_LATEX) || hasPermission(USER_GROUP.WT_CONCENTRATED)),
      children: [
        { key: PATH.PURCHASE_FRESH.substring(1), label: 'รับซื้อน้ำยางสด', permissions : (hasPermission(USER_GROUP.PURCHASE) || hasPermission(USER_GROUP.WT_LATEX) && _.get(features, 'payment_feature', false))},
        { key: PATH.PURCHASE_CONCENTRATED.substring(1), label: 'รับซื้อน้ำยางข้น', permissions : (hasPermission(USER_GROUP.PURCHASE)) || hasPermission(USER_GROUP.WT_CONCENTRATED)},
      ]
    },
    {
      icon: <DropboxOutlined />,
      label: 'สต๊อกสารเคมี',
      permissions: (hasPermission(USER_GROUP.CHEMICAL)),
      children: [
        { key: PATH.PURE_CHEMICAL.substring(1), label: 'เคมีภัณฑ์', permissions : (hasPermission(USER_GROUP.CHEMICAL) && _.get(features, 'lab_input_stock_feature', false))},
        { key: PATH.QUALITY_CHEMICAL.substring(1), label: 'เคมีคุณภาพ', permissions : (hasPermission(USER_GROUP.CHEMICAL))},
        { key: PATH.DISPENSE_CHEMICAL.substring(1), label: 'การจ่ายสารเคมี', permissions : (hasPermission(USER_GROUP.CHEMICAL) && _.get(features, 'lab_input_stock_feature', false))},
      ],
    },
    {
      key: PATH.SALE_LIST.substring(1),
      icon: <FileFilled />,
      label: 'รายการขาย',
      permissions: (hasPermission(USER_GROUP.SALE) || hasPermission(USER_GROUP.WT_CONCENTRATED))
    },
    {
      key: PATH.PRODUCE_PRE_ORDER.substring(1),
      icon: <ProductFilled />,
      label: 'ใบแจ้งผลิต',
      permissions: (hasPermission(USER_GROUP.SALE) || hasPermission(USER_GROUP.WT_CONCENTRATED))
    },
    {
      key: PATH.PURCHASE_RECORD.substring(1),
      icon: <FontAwesomeIcon icon={faFileInvoiceDollar}/>,
      label: 'บันทึกซื้อยาง',
      permissions: false
    },
    {
      icon: <FontAwesomeIcon icon={faGear} />,
      label: 'ตั้งค่า',
      permissions: hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_LATEX) || hasPermission(USER_GROUP.WT_CONCENTRATED),
      children: [
        { key: PATH.POND_TANK_SETTING.substring(1), label: 'บ่อ/แทงก์', permissions : hasPermission(USER_GROUP.MANAGER) },
        { key: PATH.PRODUCT_TYPE_SETTING.substring(1), label: 'ชนิดสินค้า', permissions : hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_CONCENTRATED)},
        { key: PATH.BUYER_SETTING.substring(1), label: 'ลูกค้า', permissions : hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_CONCENTRATED) },
        { key: PATH.SELLER_SETTING.substring(1), label: 'ผู้ขาย', permissions : hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_LATEX) || hasPermission(USER_GROUP.WT_CONCENTRATED)},
        { key: PATH.SHIPPING_SETTING.substring(1), label: 'การส่งสินค้า', permissions : hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_CONCENTRATED) },
        { key: PATH.FACTORY_SETTING.substring(1), label: 'ข้อมูลโรงงาน', permissions : hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_LATEX)},
        // { key: PATH.USER.substring(1), label: 'ผู้ใช้งาน', permissions : hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_LATEX)}
      ],
    },
    // USER GROUP ROLE QC ONLY
    {
      key : PATH.LAB_LATEX_QC.substring(1),
      icon: <FontAwesomeIcon icon={faBoxArchive} />,
      label: 'น้ำยางสด',
      permissions: (hasPermission(USER_GROUP.QC)),
    },
    {
      icon: <FontAwesomeIcon icon={faDatabase} />,
      label: 'น้ำยางข้น',
      permissions: (hasPermission(USER_GROUP.QC)),
      children: [
        { key: PATH.LAB_CON_QC.substring(1), label: 'แทงก์ปรับปรุงเคมี', permissions : hasPermission(USER_GROUP.QC)},
        { key: PATH.QC_TANK.substring(1), label: 'แทงก์การผลิต (CP) ', permissions : hasPermission(USER_GROUP.QC) },
      ]
    },
    {
      key: PATH.TRUCK_HISTORY.substring(1),
      icon: <HistoryOutlined />,
      label: 'ประวัติรถเข้า',
      permissions: (hasPermission(USER_GROUP.LAB) || hasPermission(USER_GROUP.WEIGHT)|| hasPermission(USER_GROUP.WT_LATEX) || hasPermission(USER_GROUP.WT_CONCENTRATED) || hasPermission(USER_GROUP.RP))
    },
    {
      key: PATH.REPORT.substring(1),
      icon: <FontAwesomeIcon icon={faFileExport} />,
      label: 'รายงาน',
      permissions: true
    },
    {
      key: PATH.PAYMENT_REPORT.substring(1),
      icon: <ProfileFilled />,
      label: 'รายงานรับซื้อ/จ่ายเงิน',
      permissions: (hasPermission(USER_GROUP.PAYMENT_REPORT))
    },
    {
      key: PATH.MANNUAL.substring(1),
      icon: <BookOutlined />,
      label: 'คู่มือ',
      permissions: true
    }
  ];

  const renderContent = () => {

    const selectedMenu = menus
      .flatMap((menu) => (menu.children ? menu.children : menu))
      .find((menu) => menu.key === currentMenu);
  
    switch (selectedMenu?.key) {
      case PATH.RECEIVING_LATEX.substring(1): return <ReceivingLatexView />;
      case PATH.LAB_LATEX.substring(1): return <LabLatexView />;
      case PATH.LAB_LATEX_QC.substring(1): return <LabLatexQCView />;
      case PATH.LAB_CON_QC.substring(1): return <LabConcentrateQCView />;
      case PATH.POND_LATEX.substring(1): return <PondLatexView />;
      case PATH.POND_RECIEVE_LATEX.substring(1): return <PondRecieveLatexView />;
      case PATH.STORAGE_TANK.substring(1): return <StorageTankView />;
      case PATH.QC_TANK.substring(1): return <StorageTankView />;
      case PATH.STORAGE_SKIM.substring(1): return <StorageSkimView />
      case PATH.PURCHASE_FRESH.substring(1): return <PurchaseView />;
      case PATH.PURCHASE_CONCENTRATED.substring(1): return <PurchaseCTTView/>;
      case PATH.PURE_CHEMICAL.substring(1): return <PureChemicalView />;
      case PATH.QUALITY_CHEMICAL.substring(1): return <QualityChemicalView />;
      case PATH.DISPENSE_CHEMICAL.substring(1): return <DispenseChemicalView />;
      case PATH.SALE_LIST.substring(1): return <SaleListView />;
      case PATH.PRODUCE_PRE_ORDER.substring(1): return <ProducePreorderView />;
      case PATH.POND_TANK_SETTING.substring(1): return <PondTankSettingView />;
      case PATH.BUYER_SETTING.substring(1): return <BuyerSettingView />;
      case PATH.FACTORY_SETTING.substring(1): return <FactorySettingsView />;
      case PATH.PRODUCT_TYPE_SETTING.substring(1): return <ProductTypeSettingView />;
      case PATH.SELLER_SETTING.substring(1): return <SellerSettingView/>;
      case PATH.SHIPPING_SETTING.substring(1): return <ShippingSettingView />;
      case PATH.REPORT.substring(1): return <ReportView/>;
      case PATH.PURCHASE_RECORD.substring(1): return "RECORD";
      case PATH.TRUCK_HISTORY.substring(1): return <TruckHistoryView />;
      case PATH.SKIM_CHEMICAL.substring(1): return <SkimChemicalView />;
      case PATH.MANNUAL.substring(1): return <ManualView />;
      case PATH.PAYMENT_REPORT.substring(1): return <PaymentReportView />;
      case PATH.USER.substring(1): return <UserSettingView />;
      default: return null;
    }
  };
  
  const autoRoute = (params) => {
    const firstMenu = menus.flatMap((menu) => (menu.children ? menu.children : menu)).find((menu) => menu.permissions && menu.key);
    const targetMenu = menus
      .flatMap((menu) => (menu.children ? menu.children : menu))
      .find((menu) => menu.key === params.menu);
    if (targetMenu) {
      setCurrentMenu(targetMenu.key);
    } else {
      navigate(`/${firstMenu.key}`);
      setCurrentMenu(firstMenu.key);
    }
    setLoading(false);
  };
  
  const renderMenuItems = (menus) =>{
    const filteredMonus = menus.map((menu) => menu.children ? {...menu , children : menu.children.filter((sub) => sub.permissions)} : menu)
    const permissionMenus = filteredMonus.map((menu) => {
      return {
        key: menu.key,
        icon: menu.icon,
        label: menu.label,
        children: menu.children ? renderMenuItems(menu.children) : undefined,
        extra: <Badge count={menu.notification} size='small'/>,
      }
    })

    return permissionMenus;
  };

  const onMenuSelected = (key) => {
    const selectedMenu = menus
      .flatMap((menu) => (menu.children ? menu.children : menu))
      .find((menu) => menu.key === key);
    if (selectedMenu) {
      setCurrentMenu(key);
      navigate(`/${key}`);
    }
  };

  // Render menu
  const getMenus = () => (
    <Menu
      mode="inline"
      style={{ backgroundColor: WHITE_COLOR_BG }}
      onClick={(e) => {
        onMenuSelected(e.key);
      }}
      defaultSelectedKeys={[currentMenu]}
      selectedKeys={[currentMenu]}
      items={user.id && renderMenuItems(menus.filter((menu) => menu.permissions))}
    />
  );

  React.useEffect(() => {
    if (user.id){
      autoRoute(params)
    } else {
      navigate(PATH.LOGIN)
    }
  },[user])

  React.useEffect(() => {
    fetchNotification();
  },[])

  return (
    <Spin spinning={loading}>
      <Layout style={{ minHeight: "100vh", background: WHITE_COLOR_BG }}>
        <Sider
          className="shadow"
          style={{ background: WHITE_COLOR_BG }}
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={230}
        >
          <div
            style={{
              textAlign: "center",
              marginTop: 24,
              marginBottom: 16,
            }}
          >
            <div>
              <Image
                width={'60%'}
                src={logo}
                preview={false}
              />
            </div>
            {CODE_VERSION &&
                <span style={{ color: colorPrimary, fontWeight: 'bold' }}>Version: {CODE_VERSION}</span>
            }
          </div>

          {getMenus()}
        </Sider>
        <Layout style={{ background: BG_LAYOUT_COLOR }}>
          <Header
            style={{
              padding: 0,
              background: WHITE_COLOR_BG,
              color: PRIMARY_COLOR,
              fontWeight: "bold",
            }}
          >
            <Button
              style={{
                color: BLACK_COLOR,
                fontSize: "16px",
                width: 64,
                height: 64,
              }}
              type="text"
              icon={
                collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
              }
              onClick={() => {
                setCollapsed(!collapsed);
              }}
            />

            {menus
                .flatMap((menu) => (menu.children ? menu.children : menu))
                .find((menu) => menu.key === currentMenu)?.label || "-"}

            <div
              style={{
                display: "inline-block",
                float: "right",
                marginRight: 16,
              }}
            >
              <Popover
                trigger="hover"
                title={user.full_name}
                open={openUserMenu}
                onOpenChange={(newOpen) => setOpenUserMenu(newOpen)}
                content={
                  <Space direction="vertical">
                    <Button
                      type="text"
                      style={{ textAlign: "left" }}
                      block
                      icon={<UnlockOutlined />}
                      onClick={() => setOpenChangePassword(true)}
                    >
                      เปลี่ยนรหัสผ่าน
                    </Button>
                    <Button
                      type="text"
                      style={{ textAlign: "left" }}
                      block
                      icon={<LogoutOutlined />}
                      onClick={() => setOpenLogout(true)}
                    >
                      ออกจากระบบ
                    </Button>
                  </Space>
                }
              >
                <Button
                  shape="round"
                  size="large"
                  style={{ boxShadow: "0 0 0", color: colorPrimary }}
                  onClick={() => setOpenUserMenu(true)}
                >
                  {user.first_name}
                </Button>
              </Popover>
            </div>
          </Header>
          <Content
            style={{
              margin: 24,
              minHeight: 280,
              padding: "0px 24px",
              background: colorBgContainer,
            }}>
              {renderContent()}
          </Content>
        </Layout>
      </Layout>

      <LogoutModal
        open={openLogout}
        onClose={() => setOpenLogout(false)}
        onUpdate={() => setOpenLogout(false)}
      />

      <ChangePasswordModal
        open={openChangePassword}
        onClose={() => setOpenChangePassword(false)}
      />
    </Spin>
  );
}
